module.exports = __webpack_public_path__ + "static/img/coupon_light@2x.e907abb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/anniversary/coupon_light@2x.png
// module id = yAg9
// module chunks = 0